import { forwardRef, useId } from "react";

export const Field = forwardRef(
  ({ label, hint, error, testId, multiline = false, tone = "light", className = "", ...props }, ref) => {
    const id = useId();
    const msgId = `${id}-msg`;
    const message = error || hint;
    const Tag = multiline ? "textarea" : "input";
    const dark = tone === "dark";
    return (
      <div className={className}>
        <label htmlFor={id} className={`block text-sm font-medium leading-5 ${dark ? "text-[#F8FAFC]" : "text-ax-text"}`}>
          {label}
        </label>
        <Tag
          ref={ref}
          id={id}
          data-testid={testId}
          aria-invalid={error ? true : undefined}
          aria-describedby={message ? msgId : undefined}
          className={`mt-2 block w-full rounded-[8px] border px-3 text-base placeholder:text-ax-muted transition-colors duration-150 focus:border-ax-accent focus:outline-none focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-ax-focus-ring ${
            dark
              ? "border-white/20 bg-white/5 text-white placeholder:text-white/50"
              : "bg-ax-surface text-ax-text"
          } ${
            multiline ? "min-h-[112px] resize-y py-3 leading-6" : "h-12"
          } ${error ? "border-ax-error" : dark ? "" : "border-ax-border"}`}
          {...props}
        />
        {message && (
          <p
            id={msgId}
            data-testid={testId ? `${testId}-message` : undefined}
            className={`m-0 mt-2 text-sm leading-5 ${error ? (dark ? "text-[#FCA5A5]" : "text-ax-error") : dark ? "text-white/60" : "text-ax-muted"}`}
          >
            {message}
          </p>
        )}
      </div>
    );
  },
);
Field.displayName = "Field";
